var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-textarea',_vm._b({class:{ 'error--text': _vm.$attrs['required'] && !_vm.textAreaInput },on:{"keypress":(e) => _vm.manageLimit(e),"paste":(e) => _vm.onPaste(e)},model:{value:(_vm.textAreaInput),callback:function ($$v) {_vm.textAreaInput=$$v},expression:"textAreaInput"}},'v-textarea',{
      ..._vm.$attrs,
    },false)),(_vm.counter)?_c('div',{staticClass:"text-right"},[_vm._v(" "+_vm._s(_vm.textAreaInput ? _vm.textAreaInput.length : 0)+"/"+_vm._s(_vm.counter)+" ")]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }